import React, { Component } from "react";
import PropTypes from "prop-types";
import APIManager from "modules/common/apiManager";
import SelectWithSearch from "modules/common/components/form/SelectWithSearch";
export class SelectFilterAPI extends Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    this.state = {
      loading: false,
      limit: props.limit || 20,
      options: props.options || [],
    };
    this.timer = "";
    this.getData = this.getData.bind(this);
    this.onSearch = this.onSearch.bind(this);
  }
  getData(search) {
    const { dataUrl } = this.props;
    let _this = this;
    let searchQuery = "";
    let filter = "";
    if (search) {
      searchQuery = `&search=${search}`;
    }
    if (_this.props.addFilter) {
      filter = _this.props.addFilter;
    } else {
      filter = "";
    }
    _this.setState({ loading: true });
    this.mAPI.sendGetAPI(
      `${dataUrl}?limit=${this.state.limit}&page_no=1${searchQuery}${filter}&orderBy=create_at&order=DESC`,
      (data) => {
        if (data && data.data) {
          let options = [];
          data.data.forEach((data) => {
            options.push({
              value: data._id,
              data: data,
              label: data.name || data.phone_number,
            });
          });
          console.log(`options `, options);
          _this.setState({ options: options, loading: false });
        } else if (data) {
          let options = [];
          data.forEach((data) => {
            options.push({
              value: data._id,
              data: data,
              label: data.name || data.phone_number,
            });
          });
          _this.setState({ options: options, loading: false });
        } else {
          _this.setState({ options: [], loading: false });
        }
      },
      (error, data) => {
        if (data) {
          _this.setState({ options: [], loading: false });
        } else {
          _this.setState({ options: [], loading: false });
        }
      },
      this.props.global === true ? "public" : ""
    );
  }
  onSearch(search) {
    let _this = this;
    search = search == "reload" ? "" : search;
    clearTimeout(this.timer);
    _this.setState({ loading: true });
    _this.timer = setTimeout(() => {
      _this.getData(search);
    }, 350);
  }

  componentDidMount() {
    // this.getData();
  }

  render() {
    const {
      selected,
      label,
      name,
      onSelect,
      multi,
      initialValues,
      disabled,
      placeholder,
    } = this.props;
    return (
      <SelectWithSearch
        placeholder={label}
        loading={this.state.loading}
        initialValues={initialValues}
        selectedValues={selected}
        totalOptions={this.state.options}
        label={label}
        onSelect={onSelect}
        name={name}
        search={this.onSearch}
        multi={multi}
        customOption=""
        disabled={disabled}
        showAvatar={false}
      />
    );
  }
}
SelectFilterAPI.contextTypes = {
  __: PropTypes.func,
};

export default SelectFilterAPI;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/SelectFilterAPI.js